;(function () {
  'use strict'

  angular
    .module('contrast.org.current-trace')
    .factory('currentTraceService', currentTraceServiceFactory)

  function currentTraceServiceFactory(
    $log,
    $rootScope,
    orgTraceApiConfig,
    appTracesApiConfig,
    serverVulnsApiConfig,
    ServiceUtils,
    CURRENT_TRACE_EVENTS,
    VULNERABILITY_TYPE
  ) {
    'ngInject'

    var service = {
      init: init,
      get: get,
      onChange: onChange
    }

    return service

    function init(params) {
      service.model = {
        type: params.type,
        traceUuid: params.traceUuid,
        expand: params.expand
      }
      if (params.appId) {
        service.model.appId = params.appId
      }
      if (params.serverId) {
        service.model.serverId = params.serverId
      }
      return get()
    }

    /**
     * @param {{}} [options]
     * @param {boolean} options.broadcast When true, will broadcast the change event
     * @returns {*}
     */
    function get(options) {
      var promise,
        model = service.model
      if (model.type === VULNERABILITY_TYPE.ORG) {
        promise = orgTraceApiConfig.getVulnerability(
          model.traceUuid,
          model.expand
        )
      } else if (model.type === VULNERABILITY_TYPE.APP) {
        promise = appTracesApiConfig.getVulnerability(
          model.appId,
          model.traceUuid,
          model.expand
        )
      } else if (model.type === VULNERABILITY_TYPE.SERVER) {
        promise = serverVulnsApiConfig.getVulnerability(
          model.serverId,
          model.traceUuid,
          model.expand
        )
      } else {
        $log.error(
          'could not determine which strategy to use for getting the current trace'
        )
      }
      return promise
        .then(function (response) {
          model.trace = response.data.trace
          if (angular.isObject(options) && options.broadcast) {
            _broadcast()
          }
          return model.trace
        })
        .catch(ServiceUtils.handleError)
    }

    /**
     * Event related functions
     */

    /**
     * @param {function} cb
     * @returns {function} deregister event function
     */
    function onChange(cb) {
      // disabled for CONTRAST-18258
      // eslint-disable-next-line angular/on-watch
      return $rootScope.$on(CURRENT_TRACE_EVENTS.CHANGE, function () {
        get().then(cb)
      })
    }

    function _broadcast() {
      $rootScope.$broadcast(CURRENT_TRACE_EVENTS.CHANGE, service.model.trace)
    }
  }
})()
